/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Virustotal detected url item model.
 * @export
 * @interface CRSFSecReviewVirustotalDetectedURLItem
 */
export interface CRSFSecReviewVirustotalDetectedURLItem {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewVirustotalDetectedURLItem
     */
    positives: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewVirustotalDetectedURLItem
     */
    scan_date: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewVirustotalDetectedURLItem
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewVirustotalDetectedURLItem
     */
    url: string;
}

/**
 * Check if a given object implements the CRSFSecReviewVirustotalDetectedURLItem interface.
 */
export function instanceOfCRSFSecReviewVirustotalDetectedURLItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "positives" in value;
    isInstance = isInstance && "scan_date" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function CRSFSecReviewVirustotalDetectedURLItemFromJSON(json: any): CRSFSecReviewVirustotalDetectedURLItem {
    return CRSFSecReviewVirustotalDetectedURLItemFromJSONTyped(json, false);
}

export function CRSFSecReviewVirustotalDetectedURLItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewVirustotalDetectedURLItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'positives': json['positives'],
        'scan_date': json['scan_date'],
        'total': json['total'],
        'url': json['url'],
    };
}

export function CRSFSecReviewVirustotalDetectedURLItemToJSON(value?: CRSFSecReviewVirustotalDetectedURLItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'positives': value.positives,
        'scan_date': value.scan_date,
        'total': value.total,
        'url': value.url,
    };
}

